// extracted by mini-css-extract-plugin
module.exports = {"input":"index_input__TWIL_","flex":"index_flex__1jAsV"};